export default __webpack_public_path__ + "static/workFlowImg-d9f01f09c3bfb853e598797b17f346a6.png";